<div class="interest-display-item" [ngClass]="'interest-display-type-'+type" *ngIf="interest" (click)="triggerAction('click')" [class.can-deselect]="canDeselect" [tooltip]="canDeselect ? (eCommonMessages.REMOVE | translate) : ''" placement="right" [triggers]="globals.tooltipTriggers">
  <ng-container *ngIf="showIcon">
    <span [ngClass]="eTypeIcon[interest.interestType]" [title]="(eCommonMessages.INTEREST_TYPE[interest.interestType.toUpperCase()] | translate)"></span>
    <span class="m-right-5"></span>
  </ng-container>
  <span>{{interest.name}}</span>
</div>